import * as actions from '../../ActionType/UserActionType';
const initExercise = {
    allUserGroups:[],
    createGroups:[],
    deleteUserGroups:[],
    getByIdUserGroups:[],
    addUserFormGroup:[],
    updateGroups:[],
    ftpProcess:[],
}
export const UserGroupReducer = (state = initExercise, action:any) => {
    switch (action.type) {
        case actions.CREATE_USER_GROUP: 
            return{
                ...state,
                createGroups:action.payload
            };
            case actions.ALL_USER_GROUP: 
            return{
                ...state,
                allUserGroups:action.payload
            };
            case actions.DELETE_USER_GROUP: 
            return{
                ...state,
                deleteUserGroups:action.payload
            };
            case actions.GET_USER_GROUP_BYID: 
            return{
                ...state,
                getByIdUserGroups:action.payload
            };
            case actions.ADD_USER_FORM_GROUP: 
            return{
                ...state,
                addUserFormGroup:action.payload
            };
            case actions.UPDATE_USER_GROUP: 
            return{
                ...state,
                updateGroups:action.payload
            };
            case actions.FTP_PROCESS: 
            return{
                ...state,
                ftpProcess:action.payload
            };
        default:
         return state;
    }
}